import React, { useEffect, useState } from 'react'

import Botao from '../../Mantine/Botao'
import Group from '../../Mantine/Group'

import * as S from './styles'

/**
 * @typedef {Object} Step
 * @property {boolean} [disableValidation]
 * @property {string} label
 * @property {string} subtitle
 * @property {React.ReactNode} content
 */

/**
 * @typedef {Object} StepperProps
 * @property {Step[]} [steps]
 * @property {boolean[]} [disabledNextStep]
 * @property {boolean} [allowNextStepsSelect]
 * @property {string} [prev]
 * @property {string} [next]
 * @property {string} [finish]
 * @property {() => void} onSubmit
 * @property {(() => void) | null} [close]
 */

/**
 * @param {StepperProps} props
 */
export default function Stepper({
  steps = [],
  disabledNextStep = [],
  allowNextStepsSelect = false,
  prev = 'Cancelar',
  next = 'Próximo',
  finish = 'Confirmar',
  onSubmit,
  close = null
}) {
  const [active, setActive] = useState(0)
  const [finalStep, setFinalStep] = useState(false)

  const nextStep = () =>
    setActive((current) => (current < steps.length - 1 ? current + 1 : current))

  const prevStep = () => {
    setActive((current) => {
      if (current > 0) {
        return current - 1
      } else {
        if (close) close()
        return current
      }
    })
  }

  const finishStep = () => onSubmit()

  steps = steps.map((step) => ({
    ...step,
    disableValidation: step.disableValidation !== false // default true
  }))

  useEffect(() => {
    setFinalStep(steps.length === active + 1)
  }, [active, steps])

  return (
    <>
      <S.Stepper
        active={active}
        onStepClick={setActive}
        iconSize={25}
        size="md"
        allowNextStepsSelect={allowNextStepsSelect}
      >
        {steps.map((step) => (
          <S.Stepper.Step key={step.label} label={step.label}>
            <div className="content-subtitle">{step.subtitle}</div>

            <div className="content">{step.content}</div>
          </S.Stepper.Step>
        ))}
      </S.Stepper>

      <Group position="right" mt="xl">
        <Botao
          label={!active ? prev : 'Voltar'}
          variant="outline"
          onClick={prevStep}
        />
        <Botao
          disabled={
            disabledNextStep[active] && steps[active]?.disableValidation
          }
          label={finalStep ? finish : next}
          variant="primary"
          onClick={finalStep ? finishStep : nextStep}
        />
      </Group>
    </>
  )
}
